import { createFileRoute } from '@tanstack/react-router';
import { CrmPreviewPage } from '@/pages/Crm/CrmPreviewPage';
import { AclRoute, withPermission } from '@/lib/acl';
import { crmNavItem } from '@/lib/crm/crm-nav';

function Preview() {
  return <CrmPreviewPage navId="handover" />;
}

export const Route = createFileRoute('/crm/handover')({
  component: withPermission(Preview, { key: crmNavItem('handover').access, route: AclRoute.CRM, resourceLabel: 'Delivery handover' }),
});
